<template>
  <div :class="isEnhancedMyPage ? 'purchase-history pb-16' : 'pb-16'">
    <!-- 본문 -->
    <v-sheet :class="isEnhancedMyPage ? 'mx-auto' : 'pt-6 mx-auto'">
      <component :is="reservationComponent" ref="reservationList" />
    </v-sheet>
  </div>
</template>
<script>
import ReservationListEnhanced from "./ReservationList"
import ReservationListLegacy from "./ReservationListLegacy"
import { mayUseEnhancedMyPage } from "@/util/mypageCanary"

export default {
  components: {
    ReservationListEnhanced,
    ReservationListLegacy,
  },

  data: () => ({
    //reserveComponentKey: 0,
  }),

  computed: {
    isEnhancedMyPage() {
      return mayUseEnhancedMyPage({
        email:
          this.$store.state.lafia_user &&
          this.$store.state.lafia_user.email,
        runtimeProfile: process.env.VUE_APP_RUNTIME_PROFILE,
        canaryEmails: process.env.VUE_APP_MYPAGE_CANARY_EMAILS,
      })
    },
    reservationComponent() {
      return this.isEnhancedMyPage
        ? "ReservationListEnhanced"
        : "ReservationListLegacy"
    },
  },

  created() {},

  mounted() {},

  methods: {
    load() {
      const reservationList = this.$refs.reservationList
      if (reservationList && typeof reservationList.load === "function") {
        reservationList.load()
      }
    },
  },
}
</script>
<style scoped>
.purchase-history,
.purchase-history > .v-sheet {
  background: #fffdf9;
}
</style>
